import SkeletonContent from "./SkeletonContent";

export default SkeletonContent;
